interface OAuthProvider {
  name: string;
  authUrl: string;
  tokenUrl: string;
  clientId: string;
  scopes: string[];
  redirectUri: string;
  /** Provider-specific extra query params appended to the auth URL */
  extraAuthParams?: Record<string, string>;
}

export const oauthProviders: Record<string, OAuthProvider> = {
  Microsoft: {
    name: 'Microsoft',
    authUrl: 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize',
    tokenUrl: 'https://login.microsoftonline.com/organizations/oauth2/v2.0/token',
    clientId: process.env.microsoftClientId || '',
    scopes: ['openid', 'profile', 'email', 'offline_access', 'User.Read', 'Calendars.Read', 'Calendars.ReadWrite'],
    redirectUri: 'https://cloud.prosperences.fr/login',
    extraAuthParams: {
      response_mode: 'query'
    }
  },
  Google: {
    name: 'Google',
    authUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
    tokenUrl: 'https://oauth2.googleapis.com/token',
    clientId: process.env.googleClientId || '',
    scopes: ['openid', 'profile', 'email', 'https://www.googleapis.com/auth/calendar'],
    redirectUri: 'https://cloud.prosperences.fr/login',
    extraAuthParams: {
      access_type: 'offline', // Required to receive a refresh token from Google
      prompt: 'consent'       // Forces consent screen to always obtain a fresh refresh token
    }
  }
};

export function generateAuthUrl(provider: OAuthProvider, state: string, email?: string, redirectUrlAfterLogin?: string): string {
  // Encode the redirectUrlAfterLogin in the state parameter to preserve it across OAuth flow
  const stateValue = redirectUrlAfterLogin
    ? `${state}:${encodeURIComponent(redirectUrlAfterLogin)}`
    : state;

  const params = new URLSearchParams({
    client_id: provider.clientId,
    response_type: 'code',
    redirect_uri: provider.redirectUri,
    scope: provider.scopes.join(' '),
    state: stateValue,
    login_hint: email || '',
    ...provider.extraAuthParams  // Spread provider-specific params (e.g. response_mode for Microsoft, access_type for Google)
  });

  return `${provider.authUrl}?${params.toString()}`;
}

// Helper to extract redirectCustomUrlAfterLogin from state parameter
export function extractRedirectUrlFromState(state: string): { originalState: string; redirectUrlAfterLogin?: string } {
  const parts = state.split(':');
  if (parts.length > 1) {
    const originalState = parts[0];
    const redirectUrlAfterLogin = decodeURIComponent(parts.slice(1).join(':'));
    return { originalState, redirectUrlAfterLogin };
  }
  return { originalState: state };
}